/**
 * Converts PSLocationin old format to new (v2) format
 *
 * @param {PSLocation} location
 * @returns {PSLocation2}
 */
export const location1toLocation2 = (location) => {
    return {
        source: null,
        lat: location.lat,
        lon: location.lon,
        locality: location.name,
        administrative_area: location.fullDetail,
        country: location.detail,
        country_code: location.countryCode,
        single_line: null,
    };
};
